<template>
  <div class="flex max-w-xl self-start pt-12 flex-col py-4">
    <Button
      v-if="!library.isInstalling"
      class="rounded-full px-24"
      size="lg"
      variant="primary"
      @click="library.openSEImport"
    >
      Start Import
    </Button>
    <div
      v-if="library.isInstalling"
      class="grid w-96 gap-6 justify-self-center py-4"
    >
      <LoadingSpinner class="h-16 w-16 justify-self-center" />
      <h3 class="text-center text-2xl font-light tracking-wide text-neutral-50">
        {{ library.installStepLabel }}
      </h3>

      <Progress v-model="library.installProgress" />

      <div class="text-center text-sm text-muted-foreground">
        {{ $t('This may take a few seconds, please wait') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const library = useLibraryStore();

const props = defineProps<{ doContinue: () => void }>();

watch(
  () => library.isInstalling,
  (is, was) => {
    // If was installing and now is not, import is complete
    if (!is.valueOf() && was.valueOf()) {
      props.doContinue();
    }
  },
);
</script>
